module.exports = __webpack_public_path__ + "img/cog-solid.8bba407d.svg";